<div class="m-portlet m-portlet--mobile">
  <div class="m-portlet__head">
    <div class="m-portlet__head-caption">
      <div class="m-portlet__head-title">
        <h3 class="m-portlet__head-text">
          Audit Trail | Batch Id:  {{metaData?.batchId}}
        </h3>
        <span class="form_head_title right">
          <button class="btn btn-with-border" (click)="goBack()">Back</button>
        </span>
      </div>
    </div>


  </div>
  <div class="m-content">
		<div class="row" style="padding: 20px;">
			<div class="col-md-6">
				<div class="row">
					<div class="col-md-3">
						<span>
							<b>Assessment Start Date</b>
						</span>
					</div>
					<div class="col-md-1">
						<span> : </span>
					</div>
					<div class="col-md-7">
						<span>
							{{batchData?.jobRoles[0].assessmentStartDate ? (batchData?.jobRoles[0].assessmentStartDate | date) : 'N/A'}}
							<!-- {{batchData?.jobRoles[0].assessmentStartDate ? (batchData?.jobRoles[0].assessmentStartDate | date : 'shortTime') : 'N/A'}} -->
						</span>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="row">
					<div class="col-md-3">
						<span>
							<b>Assessment End Date</b>
						</span>
					</div>
					<div class="col-md-1">
						<span> : </span>
					</div>
					<div class="col-md-7">
						<span>{{(batchData?.jobRoles[0].assessmentEndDate | date) || 'N/A'}}</span>
						<!-- <span>{{(batchData?.jobRoles[0].assessmentEndDate | date : 'shortTime') || 'N/A'}}</span> -->
					</div>
				</div>
			</div>
    </div>
    <br>

    <div class="row">
      <div *ngIf="batchData?.jobRoles[0]?.assessmentAgencyDetails?.assessmentProcessDetails?.assessmentBasedOn !== 'proctor'" class="col-lg-4">
        <!--begin::Portlet-->
        <div class="m-portlet m-portlet--mobile m-portlet--body-progress-">
          <h3 style="font-size: 17px">Action Taken By Assessor</h3>
          <div
            class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
            id="scrolling_horizontal" style="position: static; zoom: 1;">
            <table  style="border-style: double;" class="table table-striped">
              <tr>
                <th>
                  <strong>User</strong>
                </th>
                <!-- <th>
                  <strong>Recieved On</strong>
                </th> -->
                <!-- <th>
                   <strong>Status</strong>
                 </th> -->
                <th>
                  <strong>Action</strong>
                </th>
                <th>
                  <strong>Action Taken On</strong>
                </th>
              </tr>
              <tr *ngFor="let data of arAuditTrial">
                <td>{{data.actionByRole}}<br>({{data.actionBy}})</td>
                <!-- <td>{{data.actionOn | date }}</td> -->
                <td>{{displayStatus(data.action)}}</td>
                <td>{{data.actionOn | date}} - {{data.actionOn | date : 'shortTime'}}</td>
              </tr>
              <tr *ngIf="arAuditTrial && arAuditTrial.length === 0"  style="color:grey;font-size:17px">
              <td colspan="8">
                <p style="text-align:center;">No Data Found</p>
              </td>
            </tr>
            </table>
          </div>
        </div>
      </div>

      <div *ngIf="batchData?.jobRoles[0]?.assessmentAgencyDetails?.assessmentProcessDetails?.assessmentBasedOn === 'proctor'" class="col-lg-4">
        <!--begin::Portlet-->
        <div class="m-portlet m-portlet--mobile m-portlet--body-progress-">
          <h3 style="font-size: 17px">Action Taken By Proctor</h3>
          <div
            class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
            id="scrolling_horizontal" style="position: static; zoom: 1;">
            <table  style="border-style: double;" class="table table-striped">
              <tr>
                <th>
                  <strong>User</strong>
                </th>
                <!-- <th>
                  <strong>Recieved On</strong>
                </th> -->
                <!-- <th>
                   <strong>Status</strong>
                 </th> -->
                <th>
                  <strong>Action</strong>
                </th>
                <th>
                  <strong>Action Taken On</strong>
                </th>
              </tr>
              <tr *ngFor="let data of prAuditTrial">
                <td>{{data.actionByRole}}<br>({{data.actionBy}})</td>
                <!-- <td>{{data.actionOn | date }}</td> -->
                <td>{{displayStatus(data.action)}}</td>
                <td>{{data.actionOn | date}} - {{data.actionOn | date : 'shortTime'}}</td>
              </tr>
              <tr *ngIf="prAuditTrial && prAuditTrial.length === 0"  style="color:grey;font-size:17px">
              <td colspan="8">
                <p style="text-align:center;">No Data Found</p>
              </td>
            </tr>
            </table>
          </div>
        </div>
      </div>

      <!-- second -->
      <div class="col-lg-4">
        <!--begin::Portlet-->
        <div class="m-portlet m-portlet--mobile m-portlet--body-progress-">
          <h3 style="font-size: 17px">Action Taken By Assessment Agency</h3>
          <div
            class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
            id="scrolling_horizontal" style="position: static; zoom: 1;">
            <table style="border-style: double;" class="table table-striped">
              <tr>
                <th>
                  <strong>User</strong>
                </th>
                <!-- <th>
                  <strong>Recieved On</strong>
                </th> -->
                <!-- <th>
                   <strong>Status</strong>
                 </th> -->
                <th>
                  <strong>Action</strong>
                </th>
                <th>
                  <strong>Action Taken On</strong>
                </th>
                      <tr *ngFor="let data of aaAuditTrial">
                        <td>{{data.actionByRole}}<br>({{data.actionBy}})</td>
                        <!-- <td>{{data.actionOn | date }}</td> -->
                        <td>{{displayStatus(data.action)}}</td>
                        <td>{{data.actionOn | date}} - {{data.actionOn | date : 'shortTime'}}</td>
                      </tr>

                      <tr *ngIf="aaAuditTrial && aaAuditTrial.length === 0"  style="color:grey;font-size:17px">
                        <td colspan="8">
                          <p style="text-align:center;">No Data Found</p>
                        </td>
                      </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <!--begin::Portlet-->
        <div class="m-portlet m-portlet--mobile m-portlet--body-progress-">
          <h3 style="font-size: 17px">Action Taken By SSC</h3>
          <div
            class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
            id="scrolling_horizontal" style="position: static; zoom: 1;">
            <table style="border-style: double;" class="table table-striped">
              <tr>
                <th>
                  <strong>User</strong>
                </th>
                <!-- <th>
                  <strong>Recieved On</strong>
                </th> -->
                <!-- <th>
                   <strong>Status</strong>
                 </th> -->
                <th>
                  <strong>Action</strong>
                </th>
                <th>
                  <strong>Action Taken On</strong>
                </th>
                <!-- <th>
                        <strong>Date</strong>
                      </th> -->
              </tr>
              <tr *ngFor="let data of sscAuditTrial">
                <td>{{data.actionByRole}}<br>({{data.actionBy}})</td>
                <!-- <td>{{data.actionOn | date }}</td> -->
                <td>{{displayStatus(data.action)}}</td>
                <td>{{data.actionOn | date}} - {{data.actionOn | date : 'shortTime'}}</td>
              </tr>
              <tr *ngIf="sscAuditTrial && sscAuditTrial.length === 0"  style="color:grey;font-size:17px">
                <td colspan="8">
                  <p style="text-align:center;">No Data Found</p>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
